import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["spacePersonField"]
  static values = {
    autoOpen: Boolean,
    search: String,
  }

  connect() {
    if (!this.autoOpenValue || !this.hasSpacePersonFieldTarget || this.sharedPersonSelected()) {
      return
    }

    this.attempts = 0
    this.openAndSeed()
  }

  openAndSeed() {
    const selection = this.spacePersonFieldTarget.querySelector(".select2-selection")
    if (!selection) {
      this.retry(() => this.openAndSeed())
      return
    }

    selection.dispatchEvent(new MouseEvent("mousedown", {bubbles: true}))
    this.seedSearch()
  }

  seedSearch() {
    const searchField = document.querySelector(".select2-container--open .select2-search__field")
    if (!searchField) {
      this.retry(() => this.seedSearch())
      return
    }

    if (this.hasSearchValue && searchField.value.trim() === "") {
      window.setTimeout(() => this.seedSearchTerm(), 0)
    }

    searchField.focus()
    searchField.setSelectionRange(searchField.value.length, searchField.value.length)
  }

  seedSearchTerm() {
    const searchField = document.querySelector(".select2-container--open .select2-search__field")
    if (!searchField) {
      this.retry(() => this.seedSearchTerm())
      return
    }

    if (searchField.value.trim() !== "") {
      return
    }

    this.typeIntoSearchField(searchField, this.searchValue)
    searchField.focus()
    searchField.setSelectionRange(searchField.value.length, searchField.value.length)
  }

  typeIntoSearchField(searchField, value) {
    searchField.value = value

    // Select2's taggable "Create …" state is more reliable when both the input
    // and keyup handlers see the seeded value, not just the raw input event.
    searchField.dispatchEvent(new Event("input", {bubbles: true}))
    searchField.dispatchEvent(new KeyboardEvent("keyup", {
      bubbles: true,
      key: value.slice(-1) || " ",
    }))
  }

  sharedPersonSelected() {
    const select = this.spacePersonFieldTarget.querySelector("select")
    return select?.value?.trim()?.length > 0
  }

  retry(callback) {
    if (this.attempts >= 6) {
      return
    }

    this.attempts += 1
    window.setTimeout(callback, 50)
  }
}
